// Native & external imports
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
// Services
import { AppRouterService } from "src/routing/routes-service";
import { CmpAppSettings } from "src/services/cmp-app-settings.service";
import { LayoutService } from "src/services/layout.service";
// Objects
import { CmpRememberUserCamper } from "src/objects/cmp-family-member.object";
import { Subscription } from "rxjs";

@Component({
  standalone: false,
  selector: "cmp-modal-footer",
  templateUrl: "./modal-footer.component.html",
})
export class ModalFooterComponent implements OnInit {
  layoutService = inject(LayoutService);
  private cmpAppSettings = inject(CmpAppSettings);
  private router = inject(Router);
  private routerService = inject(AppRouterService);

  @Input() removeLink = false;
  @Output() privacyPolicyResponse = new EventEmitter();
  // @Output() nextCallback = new EventEmitter();
  public collapsed: boolean;
  public assetPrefix = environment.assetPrefix;
  public currentYear: string = new Date().getFullYear().toString();
  public termsAndCondition: { [index: string]: string | boolean } = {};
  public privacyPolicy: { [index: string]: string | boolean } = {};
  public showTermsModal = false;
  public companyName = "";
  public rememberCamper: CmpRememberUserCamper = new CmpRememberUserCamper();

  public refreshSubscription: Subscription;

  constructor() {
    this.termsAndCondition.show = false;
    this.privacyPolicy.show = false;
    this.collapsed = false;
  }

  ngOnInit() {
    this.refreshSubscription =
      this.layoutService.needToRefreshObservable.subscribe(() => this.init());
    this.init();
  }

  private init() {
    this.getTermsAndConditions();
    this.getPrivacyPolicy();
  }

  private getTermsAndConditions() {
    this.layoutService.getTermsAndConditions().then((response) => {
      if (response) {
        if (
          response.termsAndConditionContentSource === "text" ||
          response.termsAndConditionContentSource === "custom_url"
        ) {
          this.termsAndCondition.show = true;
          this.termsAndCondition.choice =
            response.termsAndConditionContentSource;
          this.termsAndCondition.value = response.settingValue;
        } else if (!response.termsAndConditionContentSource) {
          this.termsAndCondition.show = false;
        }
      }
    });
  }

  private getPrivacyPolicy() {
    this.layoutService.getPrivacyPolicy().then((response) => {
      if (response) {
        if (
          response.privacyPolicyContent === "text" ||
          response.privacyPolicyContent === "custom_url"
        ) {
          this.privacyPolicy.show = true;
          this.privacyPolicy.choice = response.privacyPolicyContent;
          this.privacyPolicy.value = response.settingValue;
        } else if (!response.privacyPolicyContent) {
          this.privacyPolicy.show = false;
        }
      }
    });
  }

  public openTermsAndConditionPage() {
    if (this.termsAndCondition.choice === "text") {
      // this.router.navigate([this.routerService.componentsUrl.termsAndCondition]);
      this.getTermsAndCondition();
    } else if (this.termsAndCondition.choice === "custom_url") {
      let url = "";
      if (!/^http[s]?:\/\//.test(String(this.termsAndCondition.value))) {
        url += "https://";
      }
      url += String(this.termsAndCondition.value);
      window.open(url, "_blank");
    }
  }

  public openPrivacyPolicyPage() {
    if (this.privacyPolicy.choice === "text") {
      this.router.navigate([this.routerService.componentsUrl.privacyPolicy]);
    } else if (this.privacyPolicy.choice === "custom_url") {
      // open url in another page.
      window.open(String(this.privacyPolicy.value), "_blank");
    }
  }

  /**
   * @method getTermsAndCondition
   * @description gets the terms and condition data
   */
  private getTermsAndCondition() {
    this.layoutService.getTermsAndConditions().then((response) => {
      if (response) {
        this.layoutService.termsAndCondition.value = response.settingValue;
      }
      this.layoutService.termsAndCondition.loading = false;
    });
    this.layoutService.companyName =
      this.cmpAppSettings.getAppSetting("companyName");
    this.layoutService.showTermsModal = true;
  }

  /**
   * @method logOut
   * @description Clear the localStorage on logging out the user
   * @returns void
   */
  public logOut() {
    this.layoutService.logOut();
  }
}
